import { createAction, props } from '@ngrx/store'

export const loadReleaseInfo = createAction('[ReleaseInfo] Load ReleaseInfo')
export const loadReleaseInfoSuccess = createAction('[ReleaseInfo] Load ReleaseInfo Success', props<{ data: any }>())
export const loadReleaseInfoFailure = createAction('[ReleaseInfo] Load ReleaseInfo Failure', props<{ error: any }>())

export const refreshReleaseInfo = createAction('[ReleaseInfo] Refresh ReleaseInfo')
